export var Tip;
(function (Tip) {
    Tip["FivePercent"] = "five-percent";
    Tip["TenPercent"] = "ten-percent";
    Tip["FifteenPercent"] = "fifteen-percent";
    Tip["TwentyPercent"] = "twenty-percent";
    Tip["Other"] = "other";
})(Tip || (Tip = {}));
export const tipValues = {
    [Tip.FivePercent]: 5,
    [Tip.TenPercent]: 10,
    [Tip.FifteenPercent]: 15,
    [Tip.TwentyPercent]: 20,
    [Tip.Other]: 0
};
export const tipPercentageMap = {
    5: Tip.FivePercent,
    10: Tip.TenPercent,
    15: Tip.FifteenPercent,
    20: Tip.TwentyPercent
};
export const tipDisplayValues = {
    [Tip.FivePercent]: '5%',
    [Tip.TenPercent]: '10%',
    [Tip.FifteenPercent]: '15%',
    [Tip.TwentyPercent]: '20%',
    [Tip.Other]: '0%'
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGlwcy5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJ0aXBzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLEdBTVg7QUFORCxXQUFZLEdBQUc7SUFDYixtQ0FBNEIsQ0FBQTtJQUM1QixpQ0FBMEIsQ0FBQTtJQUMxQix5Q0FBa0MsQ0FBQTtJQUNsQyx1Q0FBZ0MsQ0FBQTtJQUNoQyxzQkFBZSxDQUFBO0FBQ2pCLENBQUMsRUFOVyxHQUFHLEtBQUgsR0FBRyxRQU1kO0FBRUQsTUFBTSxDQUFDLE1BQU0sU0FBUyxHQUEyQjtJQUMvQyxDQUFDLEdBQUcsQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDO0lBQ3BCLENBQUMsR0FBRyxDQUFDLFVBQVUsQ0FBQyxFQUFFLEVBQUU7SUFDcEIsQ0FBQyxHQUFHLENBQUMsY0FBYyxDQUFDLEVBQUUsRUFBRTtJQUN4QixDQUFDLEdBQUcsQ0FBQyxhQUFhLENBQUMsRUFBRSxFQUFFO0lBQ3ZCLENBQUMsR0FBRyxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUM7Q0FDZixDQUFBO0FBRUQsTUFBTSxDQUFDLE1BQU0sZ0JBQWdCLEdBQXdCO0lBQ25ELENBQUMsRUFBRSxHQUFHLENBQUMsV0FBVztJQUNsQixFQUFFLEVBQUUsR0FBRyxDQUFDLFVBQVU7SUFDbEIsRUFBRSxFQUFFLEdBQUcsQ0FBQyxjQUFjO0lBQ3RCLEVBQUUsRUFBRSxHQUFHLENBQUMsYUFBYTtDQUN0QixDQUFBO0FBRUQsTUFBTSxDQUFDLE1BQU0sZ0JBQWdCLEdBQWlDO0lBQzVELENBQUMsR0FBRyxDQUFDLFdBQVcsQ0FBQyxFQUFFLElBQUk7SUFDdkIsQ0FBQyxHQUFHLENBQUMsVUFBVSxDQUFDLEVBQUUsS0FBSztJQUN2QixDQUFDLEdBQUcsQ0FBQyxjQUFjLENBQUMsRUFBRSxLQUFLO0lBQzNCLENBQUMsR0FBRyxDQUFDLGFBQWEsQ0FBQyxFQUFFLEtBQUs7SUFDMUIsQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLEVBQUUsSUFBSTtDQUNsQixDQUFBIn0=